import SystemApi from '../system/_systemApi';

class StateBankObjectAPI extends SystemApi {
  constructor() {
    super();
  }
  controllerName = 'StateBanks';
}

export default new StateBankObjectAPI();
